<template>
  <div class="arp-choice" data-tour="arp-choice">
    <div class="arp-choice__cards">
      <button
        type="button"
        class="arp-choice__card"
        data-tour="arp-choice-vencedor"
        @click="$emit('select', 'vencedor')"
      >
        <span class="arp-choice__icon">
          <b-icon icon="trophy" size="is-large" type="is-primary" />
        </span>
        <span class="arp-choice__body">
          <strong>Gerar ARP para um Vencedor</strong>
          <p>
            Gerar a ata para o fornecedor vencedor do certame, com os itens e valores adjudicados e
            homologados.
          </p>
        </span>
      </button>

      <button
        type="button"
        class="arp-choice__card"
        data-tour="arp-choice-reserva"
        @click="$emit('select', 'reserva')"
      >
        <span class="arp-choice__icon">
          <b-icon icon="format-list-checks" size="is-large" type="is-primary" />
        </span>
        <span class="arp-choice__body">
          <strong>Gerar ARP do Licitante Convocado</strong>
          <p>
            Gere a Ata de Registro de Preços para o licitante do Cadastro de Reserva que já foi
            convocado para substituir o fornecedor anterior, conforme a ordem de classificação.
          </p>
        </span>
      </button>

      <button
        type="button"
        class="arp-choice__card"
        data-tour="arp-choice-propria"
        @click="$emit('select', 'propria')"
      >
        <span class="arp-choice__icon">
          <b-icon icon="upload" size="is-large" type="is-primary" />
        </span>
        <span class="arp-choice__body">
          <strong>Enviar ARP Própria</strong>
          <p>Enviar uma ARP já gerada fora do sistema e vinculá-la a este certame.</p>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArpChoice',
};
</script>

<style scoped>
.arp-choice {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.arp-choice__cards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

.arp-choice__card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
  flex: 1 1 0;
  min-width: 220px;
  height: 120px;
  text-align: left;
  padding: 1.25rem 1.5rem;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.arp-choice__card:hover {
  border-color: #214bb5;
  box-shadow: 0 2px 8px rgba(33, 75, 181, 0.08);
}

.arp-choice__icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
}

.arp-choice__icon >>> .icon {
  font-size: 2.5rem;
  height: 2.5rem;
  width: 2.5rem;
}

.arp-choice__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.35rem;
  min-width: 0;
  flex: 1;
}

.arp-choice__body strong {
  display: block;
  color: #214bb5;
  font-size: 1rem;
  line-height: 1.3;
}

.arp-choice__body p {
  margin: 0;
  color: #7a7a7a;
  font-size: 0.875rem;
  line-height: 1.4;
}
</style>
